import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EnvironmentProvider {

  /**
   * Dashboardの稼働環境が本番SPOKEか否か判定する.
   * 
   * @returns 判定結果
   */
  public isProdSpoke(): boolean {
    const url = `${location.hostname}/${location.href.split('/')[3]}`;
    const profile = environment.profiles.find((profile) => profile.url == url);

    if (!profile) {
      return false;
    }

    return (profile.name === 'prod-spoke');
  }
}



// WEBPACK FOOTER //
// ./src/providers/environment/environment.ts